import { render, staticRenderFns } from "./SupervisorEdit.vue?vue&type=template&id=79ec6437"
import script from "./SupervisorEdit.vue?vue&type=script&lang=js"
export * from "./SupervisorEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports